import { ApplicationExceptionHandler } from '@gtpl/shared-utils/error-messages';
import { Module } from '@nestjs/common';
import { TypeOrmModule } from '@nestjs/typeorm';
import { DamageReasonAdapter } from './dto/item-damage-reason.adapter';
import { DamageReason } from './item-damage-reason.entity';
import { ItemDamageReasonsController } from './item-damage-reasons.controller';
import { ItemDamageReasonsService } from './item-damage-reasons.service';

@Module({
  imports: [
    TypeOrmModule.forFeature([DamageReason]),
  ],
  controllers: [ItemDamageReasonsController],
  providers: [ItemDamageReasonsService,DamageReasonAdapter,ApplicationExceptionHandler]
})
export class ItemDamageReasonsModule {}
